// eslint-disable-next-line import/no-cycle
import AdvisorProxyApi from '@advisor/advisorProxyApi';
import RwClientService from '@advisor/rwSdk/ClientService';
import Goal from '@advisor/models/store/goal/index';
import Portfolio from '@advisor/models/Portfolio';
import exceptionHandler from '@advisor/util/exceptionHandler';

const stateObj = function () {
  return new Goal();
};

const getters = {
  isAgeType: (state) => {
    if (state.goalDetail) {
      return parseInt(state.goalDetail.displayType, 10) === 2 || parseInt(state.goalDetail.displayType, 10) === 3;
    }

    return null;
  },

  isTargetType: (state) => {
    if (state.goalDetail) {
      return parseInt(state.goalDetail.displayType, 10) === 1;
    }

    return null;
  },

  isEmptyType: (state) => {
    if (state.goalDetail) {
      return parseInt(state.goalDetail.displayType, 10) === 0;
    }

    return null;
  },
};

const actions = {
  async getAll({commit}, params) {
    try {
      const goals = await AdvisorProxyApi.getGoals(params);
      const allGoals = {
        goals: goals.data.data,
      };

      commit('SET_ALL', allGoals);
    } catch (error) {
      exceptionHandler.handleGenericException('goal.getAll', error);
    }
  },

  /**
   * Get goal accounts based on goalId
   */

  async getGoalAccounts({commit}, payload) {
    try {
      const sdkResponse = await RwClientService.getClientAccountsByGoalId(payload).catch((error) => {
        throw error;
      });

      commit('SET_GOAL_ACCOUNTS', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('goal.getGoalAccounts', error);

      return Promise.reject(error);
    }
  },
  /**
   * Get goal detail based on goalId
   */
  async getGoalDetail({commit}, payload) {
    try {
      const sdkResponse = await RwClientService.getGoalByGoalId(payload);
      const sdkResponseData = {data: sdkResponse};

      commit('SET_GOAL_DETAIL', sdkResponseData);

      return Promise.resolve(sdkResponseData);
    } catch (error) {
      exceptionHandler.handleGenericException('goal.getGoalDetail', error);

      return Promise.reject(error);
    }
  },
  /**
   * attach or detach the account to the goal.
   */
  async attachAccountToGoal(_, payload) {
    try {
      const sdkResponse = await RwClientService.attachGoalToAccounts(payload);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('goal.attachAccountToGoal', error);

      return Promise.reject(error);
    }
  },

  updateRoboStatus({commit}, payload) {
    commit('SET_ROBO_STATUS', payload);
  },
};

const mutations = {
  SET_ALL(state, payload) {
    state.allGoals = payload.goals;
  },

  SET_GOAL_ACCOUNTS(state, payload) {
    state.goalAccounts = payload;
  },

  SET_GOAL_DETAIL(state, payload) {
    state.goalDetail = payload.data;
  },

  SET_CURRENT_PORTFOLIO(state, payload) {
    state.currentPortfolio = new Portfolio(payload[0]);
  },
  SET_TARGET_PORTFOLIO(state, payload) {
    state.targetPortfolio = new Portfolio(payload[0]);
  },
  SET_ROBO_STATUS(state, payload) {
    state.goalAccounts.some((account) => {
      if (String(account.accountId) === String(payload.accountId)) {
        // eslint-disable-next-line no-param-reassign
        account.roboStatus = payload.roboStatus;

        return true;
      }

      return false;
    });
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
